<template>
  <v-alert
    v-if="hasErrors"
    type="error"
    class="ma-4"
    border="left"
    dense
    color="red lighten-2"
  >
    <ul class="ma-0 pa-0">
      <li v-for="(messages, field) in errors" :key="field">
        <strong v-if="field !== 'non_field_errors'">{{ field | cleanSnake }}:</strong>
        <div v-for="(msg, idx) in messages" :key="idx">
          {{ msg }}
        </div>
      </li>
    </ul>
  </v-alert>
</template>

<script>
export default {
  name: "ApiErrorAlert",
  props: {
    errors: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasErrors() {
      return this.errors && Object.keys(this.errors).length > 0
    }
  },
  filters: {
    cleanSnake(value) {
      if (!value) return ""
      return value.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())
    }
  }
}
</script>

<style scoped>
ul {
  list-style-type: none;
}
</style>
